import Email from "../../components/Email";
import IconLabeledItem from "../../components/IconLabeledItem"
import LabeledContainer from "../../components/LabeledContainer";
import {
   Email as EmailIcon,
   Event as DobIcon,
   Home as AddressIcon, Numbers, 
   Phone as PhoneIcon, 
   Wc as GenderIcon
} from "@mui/icons-material";
import Phone from "../../components/Phone";
import Address from "../../components/Address";

/**
 * 
 * @param {object} param0 
 * @param {string} param0.title
 * @param {object} param0.info
 * @param {string} param0.info.name
 * @param {string} param0.info.surname
 * @param {string} param0.info.email
 * @param {string} param0.info.gender
 * @param {string} param0.info.phone
 * @param {string} param0.info.national_id
 * @param {string} param0.info.dob
 * @param {string} param0.info.address
 * @param {import("react").ReactNode | import("react").ReactNode[]} param0.actions
 * @returns 
 */
export default function EntityInfo({ title= "Details", info, actions }) {
   
   return <LabeledContainer label={title} className="rounded-lg p-4">
      <div className="text-lg text-gray-600">
         {info.name} {info.surname}
      </div>
      <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-2">
         {
            info.email && <IconLabeledItem
               icon={EmailIcon} 
               item={<Email email={info.email} />}
            />
         }
         {
            info.gender && <IconLabeledItem icon={GenderIcon} item={<span className="capitalize">{info.gender}</span>} />
         }
         {  
            info.phone && <IconLabeledItem
               icon={PhoneIcon} 
               item={<Phone phone={info.phone} />}
            />
         }
         {
            info.national_id && <IconLabeledItem icon={Numbers} item={info.national_id} />
         }
         {
            info.dob && <IconLabeledItem icon={DobIcon} item={new Date(info.dob).toDateString().replace(/^\S+\s/,'')} />
         }
      </div>
      {
         info.address && <div className="mt-4">
            <IconLabeledItem icon={AddressIcon} item={<Address address={info.address} />} />
         </div>
      }
      {
         actions && <div className="mt-4 flex gap-2 justify-end">
            {actions}
         </div>
      }
   </LabeledContainer>
}